<template>
  <div
    class="flex h-full w-full flex-col justify-between overflow-hidden rounded border border-solid border-gray-500 bg-white p-3 tablet:p-4 desktop:p-5"
  >
    <div>
      <div class="w-full max-w-[160px]">
        <figure class="relative block aspect-video w-full overflow-hidden">
          <img
            :src="contextThumbnail"
            :alt="itemData.name || itemData.description"
            loading="lazy"
            class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
          />
        </figure>
      </div>
      <h3 class="mb-2 line-clamp-2 text-base font-bold">
        {{ itemData.name }}
      </h3>
      <p class="mb-2 line-clamp-4 text-sm text-gray-600">
        {{ itemData.description }}
      </p>
    </div>
    <div class="flex flex-wrap">
      <div
        v-for="area in itemData.areas"
        :key="hash(area)"
        class="mr-2 mt-2 rounded-3xl border border-solid border-gray-300 bg-gray-200 px-2 py-0.5 text-xs font-bold text-gray-600"
      >
        <span class="line-clamp-1">{{ area }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { IItem } from '@/components/Shared/Suite/Dfsi/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IItem;
    urlConnector?: TUrlConnector;
  }

  const props = defineProps<IProps>();

  const { provideResponsiveImgUrl } = useSolutionsData();

  const contextThumbnail = computed((): string => {
    const { thumbnail } = props.itemData;
    if (!thumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  });
</script>
